import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { getPartners } from "@/lib/api";
import { Building2 } from "lucide-react";

export default function PartnersSection() {
  const [partners, setPartners] = useState([]);
  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  useEffect(() => {
    getPartners().then((res) => setPartners(res.data)).catch(() => {});
  }, []);

  return (
    <section id="partners" data-testid="partners-section" className="py-24 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#1670B9] mb-4">
            Partenaires
          </p>
          <h2
            className="font-['Quicksand'] text-3xl lg:text-4xl font-medium tracking-tight text-slate-800"
            data-testid="partners-title"
          >
            Nos collaborations
          </h2>
        </motion.div>

        {partners.length === 0 ? (
          <div className="text-center py-16 text-slate-400">
            <Building2 className="w-12 h-12 mx-auto mb-4 text-slate-300" />
            <p className="text-lg">Les partenaires seront ajoutés via le panneau d'administration.</p>
          </div>
        ) : (
          <div className="flex flex-wrap justify-center items-center gap-10 md:gap-16">
            {partners.map((partner, i) => (
              <motion.a
                key={partner.id}
                href={partner.website || "#"}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={inView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className="group flex flex-col items-center"
                data-testid={`partner-${i}`}
              >
                {partner.logo_url ? (
                  <img
                    src={partner.logo_url}
                    alt={partner.name}
                    className="h-16 w-auto grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                  />
                ) : (
                  <div className="w-24 h-16 bg-slate-100 rounded-xl flex items-center justify-center grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300">
                    <Building2 className="w-8 h-8 text-[#1670B9]" />
                  </div>
                )}
                <span className="text-xs text-slate-400 mt-2 group-hover:text-slate-600 transition-colors">
                  {partner.name}
                </span>
              </motion.a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
